export const INITIAL_STATE = {
    promo_data: {
        section_title: null,
        promos: [
            {
                type: null,
                title: null,
                url: null,
            },
        ],
    },
    brand_data: {
        section_title: null,
        brand_ids: [],
    },
    product_data: {
        section_title: null,
        product_ids: [],
    },
}

export const GET_FIELD_NAME = {
    promo_data: { section_title: 'Title section', promos: 'Promo item' },
    brand_data: { section_title: 'Title highlight brand', brand_ids: 'Brand item' },
    product_data: { section_title: 'Title highlight product', product_ids: 'Product item' },
}

export const GET_ITEM_FIELD_NAME = {
    type: 'Type promo',
    title: 'Title promo',
    url: 'Link URL promo',
}
